export const SITE_URL = 'https://moritours.com';
export const SITE_NAME = 'Mori Tours';
export const WHATSAPP_NUMBER = '255765186646';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const WHATSAPP_DISPLAY = '+255 765 186 646';
export const CONTACT_EMAILS = [
  { label: 'info@moritours.com', href: 'mailto:info@moritours.com' },
  { label: 'info@moritours.co.tz', href: 'mailto:info@moritours.co.tz' },
];
